import React, { Component, useState } from "react";
import PropTypes from "prop-types";
import { withRouter, Link } from "react-router-dom";
import { connect } from "react-redux";
import MetaTags from "react-meta-tags";
import { withTranslation } from "react-i18next";
import { isEmpty, map } from "lodash"
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "flatpickr/dist/themes/material_blue.css";
import { Formik, Field, Form, ErrorMessage } from "formik";
import DeleteModal from "../../../components/Common/DeleteModal";
import * as Yup from "yup";
import {
  getProjectUUIDAction,
  addProjectMedia, 
  getProjectMedia,
  addProjectLink, 
  getProjectLink,
  getProjectOpenHouseFiles,
  deleteProjectOpenHouseFile,
  addOpenhouseForm,
  getOpenhouseForm
} from "../../../store/actions";
import ProjectSidebar from "../../../components/VerticalLayout/ProjectSidebar";
import classnames from "classnames";
import axios from "axios"
import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"
import PlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-places-autocomplete';
import {
  Row,
  Col,
  CardBody,
  Card,
  CardText,
  Container,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  FormGroup,
  Label,
  Input,
  Button,
  InputGroup,
  Offcanvas,
  OffcanvasHeader,
  OffcanvasBody,
  CardHeader,
  CardTitle
} from "reactstrap";
//Import Breadcrumb
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import FileBase64 from "../../../components/Common/FileBase64";
import WebpagesMenu from "./menu/webpages-menu";
import WebPageBreadcrumbs from "components/Common/WebpageBreadcrumb";
import { BlobServiceClient } from '@azure/storage-blob';
import Swal from 'sweetalert2'
import CopyText from "components/buttons/copyBtn";
import SaveButton from "components/buttons/save";
import img1 from "../../../assets/img/doc-1.png"
import img2 from "../../../assets/img/doc-2.png"
import img3 from "../../../assets/img/doc-3.png"
import TimePicker from "components/dropdowns/Timepicker";
import moment from "moment";
import step1 from "../../../assets/img/step-1.png"
import step2 from "../../../assets/img/step-2.png"
import step3 from "../../../assets/img/step-3.png"
import arrowImg from "../../../assets/img/arrow-img.png"
import createIcon from "../../../assets/img/create-icon.png"
import { on } from "solid-js";
import Moment from "react-moment";
import { azureConfig } from "helpers/azureConfig";
import SafeField from "helpers/SafeField";
class ProjectsCreate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      files: [],
      isRight: false,
      activeTab1: "1",
      fileUploaded: false,
    };
    //this.onFileChange = this.onFileChange.bind(this);
    this.toggleRightCanvas = this.toggleRightCanvas.bind(this);
    this.toggleBackdrop = this.toggleBackdrop.bind(this);
    this.handleProjectDocumentSubmit = this.handleProjectDocumentSubmit.bind(this)
    this.handleProjectLinkSubmit = this.handleProjectLinkSubmit.bind(this)
    this.toggle1 = this.toggle1.bind(this);
    this.onClickDelete = this.onClickDelete.bind(this);
  }
  handleStartTime = (setFieldValue, values) => {
    const { startHrs, startMin, startDif } = values;
    const hours = parseInt(startHrs, 10);
    const minutes = parseInt(startMin, 10);
    const meridiem = startDif === 'PM' && hours < 12 ? hours + 12 : hours;
    const time = `${meridiem}:${minutes < 10 ? '0' + minutes : minutes}`;

    setFieldValue('openhouseStartTime', time);
  };

  handleEndTime = (setFieldValue, values) => {
    const { endHrs, endMin, endDif } = values;
    const hours = parseInt(endHrs, 10);
    const minutes = parseInt(endMin, 10);
    const meridiem = endDif === 'PM' && hours < 12 ? hours + 12 : hours;
    const time = `${meridiem}:${minutes < 10 ? '0' + minutes : minutes}`;

    setFieldValue('openhouseEndTime', time);
  };
    handlePlaceSelected = (address, setFieldValue) => {
      geocodeByAddress(address)
        .then(results => {
          const place = results[0];
          const addressComponents = place.address_components;
          
          const getComponent = (types) => {
            const component = addressComponents.find((component) =>
              types.every((type) => component.types.includes(type))
            );
            return component ? component.long_name : '';
          };
          const latitude = place.geometry.location.lat();
          const longitude = place.geometry.location.lng();
          setFieldValue('address', place.formatted_address);
          setFieldValue('longitude', longitude);
          setFieldValue('latitude', latitude);
        })
        .catch(error => console.error('Error', error));
    };
 handleSubmit = (values, actions) => {
    const payload = {
      projectId: values.projectId,
      projectGuid:values.projectGuid,
      projectName: values.projectName,
      openhouseName: values.openhouseName,
      openhouseDate: values.openhouseDate ? moment(values.openhouseDate).format('YYYY-MM-DD') : null,
      openhouseStartTime: values.openhouseStartTime,
      openhouseEndTime: values.openhouseEndTime,
      openhouseType: parseInt(values.openhouseType),
      address: values.address,
      location: values.location,
      longitude: values.longitude.toString(),
      latitude: values.latitude.toString(),
      agentId:parseInt(localStorage.getItem("userId")),
      IsActive:true,
      openhouseNotes: values.openhouseNotes,
    };
    this.props.addOpenhouseForm(payload)
  }
  toggleDeleteModal = () => {
    this.setState(prevState => ({
      deleteModal: !prevState.deleteModal,
    }));
  };
  onClickDelete = (opfile) => {
    this.setState({ opfile: opfile });
    this.setState({ deleteModal: true });
  };

  handleDeleteFile = () => {
    const { onDeleteFile } = this.props;
    const { opfile } = this.state;
    //
    if (opfile.id !== undefined) {
      onDeleteFile(opfile);
      this.setState({ deleteModal: false });
    }
  };
  toggle1(tab) {
    if (this.state.activeTab1 !== tab) {
      this.setState({
        activeTab1: tab,
      });
    }
  }
  toggleBackdrop() {
    this.setState({ isBackdrop: !this.state.isBackdrop });
  }
  toggle() {
    this.setState(prevState => ({
      isRight: !prevState.isRight
    }));
  }
  toggleRightCanvas() {
    this.setState({ isRight: !this.state.isRight });
    //this.toggle();
  }
  getFiles(files) {
    this.setState({ files: files });
    
  }
  handleChange = setValue => {
    this.setState({ setValue });
  };

  handleProjectDocumentSubmit(value){
    this.props.addProjectMedia(value, this.props.history);
    this.toggle();
  }
  handleProjectLinkSubmit(value){
    this.props.addProjectLink(value, this.props.history);
    this.toggle();
  }
  componentDidMount() {
    const { match: { params }, ongetProjectUUIDAction, onGetProjectMedia, onGetProjectLink, onGetProjectOpenHouseFiles, onGetOpenhouseForm } = this.props;
    if (params && params.projectId) {
      ongetProjectUUIDAction(params.projectId);
      onGetProjectMedia(params.projectId);
      onGetProjectLink(params.projectId);
      onGetProjectOpenHouseFiles(localStorage.getItem("userId"))
      onGetOpenhouseForm(params.projectId);
    }
  }

  handleUncheckedCheckbox(document){
    
  }
  async handleFileChange(event, setFieldValue) {
    const file = event.currentTarget.files[0];
    if (file) {
      const maxSize = 5 * 1024 * 1024;
     const allowedTypes = [
        'application/pdf',
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // .docx
        'image/jpeg',
        'image/png',
        'image/webp',
        
      ];


      const allowedExtensions = [
        '.pdf',
        '.doc',
        '.docx',
        '.jpg',
        '.jpeg',
        '.png',
        '.webp',
        
      ];
      const fileExtension = file.name.slice(file.name.lastIndexOf('.')).toLowerCase();
      if (!allowedTypes.includes(file.type) || !allowedExtensions.includes(fileExtension)) {
        Swal.fire({
          title: 'File type or extension not allowed',
          text: 'Please upload a PDF, DOC, JPG, or PNG file.',
          icon: 'warning',
          confirmButtonText: 'OK',
        });
        //alert('Invalid file type. Please upload a PDF, DOC, JPG, or PNG file.');
        return;
      }
      if (file.size > maxSize) {
        Swal.fire({
          title: 'Size not allowed',
          text: 'Please Upload Maximum 5MB File',
          icon: 'warning',
          confirmButtonText: 'OK',
        });
       
      }
      this.setState({ btnloading: true });
       const sasToken = azureConfig.sasToken
           const containerName = azureConfig.containerName;
           const storageAccountName = azureConfig.storageAccountName;
      const fileName = `${Date.now()}_${file.name}`;
      const blobServiceClient = new BlobServiceClient(
        `https://${storageAccountName}.blob.core.windows.net?${sasToken}`
      );
      const containerClient = blobServiceClient.getContainerClient(containerName);
      const blobClient = containerClient.getBlockBlobClient(fileName);

      try {
        await blobClient.uploadBrowserData(file, {
          blobHTTPHeaders: { blobContentType: file.type }
        });

     
        if (setFieldValue) {
          const fileUrl = `https://${storageAccountName}.blob.core.windows.net/${containerName}/${fileName}`;
          setFieldValue(`projectDocumentLink`, fileUrl);
          setFieldValue(`projectDocumentContent`, fileUrl);
          this.setState({ fileUploaded: true });
        }
      } catch (error) {
        console.error('Error uploading file:', error);

      }
    }
  }
  render() {
    const { projectData, documents, links, opfiles, onGetProjectOpenHouseFiles, onGetProjectMedia, onGetProjectLink, openhouseformdatass, isResponsive } = this.props;
    const { deleteModal, fileUploaded} = this.state;
    return (
      <React.Fragment>
        {this.props.loading && this.props.loading ? (
          <div className="loading">Loading&#8230;</div>
        ) : null}
        <ToastContainer autoClose={2000} />
        <DeleteModal
          show={deleteModal}
          onDeleteClick={this.handleDeleteFile}
          onCloseClick={() => this.setState({ deleteModal: false })}
        />
        <div className="page-content project-page-content">
          <MetaTags>
            <title>Campaigns | Realty Space</title>
          </MetaTags>
          <Container fluid className="ps-0 ">
            <Row>
              <Col sm="2" className="pe-0">
                <ProjectSidebar isResponsive={isResponsive} />
              </Col>
              <Col sm="10" className="ps-0">
                <Row className="project-header">
                  <Col sm="7">
                    <WebPageBreadcrumbs
                      title={this.props.t("Projects")}
                      breadcrumbItem={this.props.t("Open House")}
                    />
                  </Col>
                  <Col sm="4">
                    <h2 className="">
                      {this.props.t(projectData.projectName)}
                    </h2>
                  </Col>
                </Row>
                <WebpagesMenu isResponsive={isResponsive} />
                <Card>
                  <CardBody>
                    <TabContent
                      activeTab={this.state.activeTab}
                      className="p-3 text-muted"
                    >
                      <Row>
                        <Col sm="12">
                        <div className="link-page">
                        <h5>
                        <span><a target="_blank" rel="noreferrer" href={"https://openhouse.realtyspacehub.com/" + this.props.match.params.projectId}><i className="bx bx-link-external"></i> Preview & share</a></span> <img src={arrowImg} width="40" className="me-2" /> <strong>Note: You can copy and paste the preview  URL with prospects.</strong>

                       {projectData.openhouseURLQR && (  
                           <a className="float-end" style={{color:'#000'}} target="_blank" rel="noreferrer" href={"https://openhouse.realtyspacehub.com/" + this.props.match.params.projectId}>Scan QR code for registration <img src={projectData.openhouseURLQR} alt="QR Code" className="ms-2" width="50" /></a>

                        )} 
                      
                      </h5>
                        </div>
                        </Col>
                      </Row>
                            <Row>
                                                                      <Col sm="2" className="d-flex">
                                                                        <Card className="border-full mt-4 w-100">
                                                                            <CardHeader><h5 className="font-size-18" style={{fontWeight:'bold'}}><img src={step1}  width="40" className="me-2" /> Purpose</h5></CardHeader>
                                                                            <CardBody className="d-flex flex-column">
                                                                                <p className="text-dark font-size-16">Use the open house link to register clients digitally.</p>
                                                                            </CardBody>
                                                                        </Card>
                                                                      </Col>
                                                                       <Col sm="5" className="d-flex">
                                                                        <Card className="border-full mt-4 w-100">
                                                                            <CardHeader><h5 className="font-size-18" style={{fontWeight:'bold'}}><img src={step2}  width="40" className="me-2" /> How it works</h5></CardHeader>
                                                                            <CardBody className="d-flex flex-column">
                                                                                  <ol className="text-dark font-size-16">
                                                                                      <li>The system auto-generates an open house visitor registration form.</li>
                                                                                      <li>When a visitor fills out the form, they receive an email with a link/attachment with the document selected.</li>
                                                                                      <li>Visitor information is captured in the system for agent follow-up.</li>
                                                                                  
                                                                                  </ol>
                                                                            </CardBody>
                                                                        </Card>
                                                                      </Col>
                                            
                                                                      <Col sm="5" className="d-flex">
                                                                        <Card className="border-full mt-4 w-100">
                                                                            <CardHeader><h5 className="font-size-18" style={{fontWeight:'bold'}}><img src={step3}  width="40" className="me-2" /> How To Use</h5></CardHeader>
                                                                            <CardBody className="d-flex flex-column">
                                                                          
                                                                                  <ol className="text-dark font-size-16">
                                                                                      <li>Create the open house by setting the date/times for the open house.</li>
                                                                                      <li>Select or upload the documents that visitors should receive by email once they submit the registration form.</li>
                                                                                       <li>Share the open house link with clients through social media, WhatsApp, or mass email to maximize registrations.</li>
                                                                                  </ol>
                                            
                                                                                  
                                                                          
                                                                            </CardBody>
                                                                        </Card>
                                                                      </Col>
                                                                    </Row>
                     <Row>
                                      <Col sm="12">
                                        <Card className="border-full mt-4">
                                            <CardBody>
                                              <h5 className="font-size-18 mb-20" style={{fontWeight:'bold'}}>All</h5>
                                              <table className="table table-striped">
                                                                                <thead className="">
                                                                                    <tr>
                                                                                        
                                                                                        <th>Date</th>
                                                                                        <th>Start Time</th>
                                                                                        <th>End Time</th>
                                                                                        {!isResponsive && (
                                                                                          <>
                                                                                           <th>Type</th>
                                                                                            <th>Location</th>
                                                                                            <th>Link</th>
                                                                                          </>
                                                                                        )}
                                                                                       
                                                                                      
                                                                                       
                    
                    
                                                                                    </tr>
                                                                                </thead>
                                                                                <tbody>
                                                                                {map(openhouseformdatass, (event, prokey) => (
                                                                                 <tr key={prokey}>
                                                                              
                                                                                  <td><Moment format="D MMM YY">{event.openhouseDate}</Moment></td>
                                                                                  <td>{event.openhouseStartTime}</td>
                                                                                  <td>{event.openhouseEndTime}</td>
                                                                                    {!isResponsive && (
                                                                                          <>
                                                                                  <td>{event.openhouseType === 0 ? 'In-person': 'Online'}</td>
                                                                                  <td>{event.openhouseType === 0 ? event.address : event.location}</td>
                                                                                  <td><a target="_blank" rel="noreferrer" href={"https://openhouse.realtyspacehub.com/" + this.props.match.params.projectId}>View</a></td>
                                                                                  </>
                                                                                    )}
                                                                                 </tr>
                                                                                ))}
                                                                                </tbody>
                                                                            </table>
                                               
                                             
                                           
                                            </CardBody>
                                          </Card>
                                      </Col>
                                    </Row>
                      <Row className="align-items-stretch mt-4"> 
                                              <Col sm="12">
                                              <Card className="border-full">
                                <CardHeader>
                                <h5 className="font-size-18" style={{fontWeight:'bold'}}><img src={createIcon} width={40} className="me-2" /> Create new open house</h5>
                                
                                </CardHeader>
                                <CardBody>
                                    <Formik
                                              enableReinitialize={true}
                                              initialValues={{
                                                projectId:projectData.id,
                                                projectGuid:projectData.preConsProjectGuid,
                                                projectName:projectData.projectName,
                                                openhouseType:"0",
                                                address:'',
                                                longitude:'',
                                                latitude:'',
                                                openhouseName: 'Open House',
                                                openhouseDate: (this.state && this.state.openhouseDate) || "",
                                                openhouseStartTime:'',
                                                openhouseEndTime:'',
                                                location: (this.state && this.state.location) || "",
                                                checkedItems: []
                                
                                              }}
                                              validationSchema={Yup.object().shape({
                                                openhouseName: Yup.string().required("This is Required"),
                                                openhouseDate: Yup.string().required("This is Required"),
                                                  openhouseStartTime:Yup.string().required("This is Required"),
                                                openhouseEndTime:Yup.string().required("This is Required"),
                                                openhouseType : Yup.string().required("This is Required"),
                                                address: Yup.string().when('openhouseType', {
                                                  is: '1',
                                                  then: Yup.string().required('This is Required'),
                                                }),
                                                location: Yup.string().when('openhouseType', {
                                                  is: '2',
                                                  then: Yup.string().required('This is Required'),
                                                }),
                                              })}
                                
                                              onSubmit={this.handleSubmit}
                                            >
                                              {({ errors, touched, values, handleChange, setFieldValue, setFieldTouched }) => (
                                                <Form
                                                  className="needs-validation"
                                                >
                                                
                                
                                                  <Row>
                                                  
                                                    <Col md="2">
                                                     <FormGroup className="">
                                                        <Label htmlFor="openhouseDate *">
                                                          {this.props.t("Enter date*")}
                                                        </Label>
                                                       
                                                    
                                                    <Flatpickr
                                                        className={
                                                            "form-control" +
                                                            (errors.openhouseDate && touched.openhouseDate
                                                            ? " is-invalid"
                                                            : "")
                                                        }
                                                        placeholder=""
                                                        onChange={(value) => setFieldValue('openhouseDate', value[0])}
                                                        options={{
                                                            altInput: false,
                                                            altFormat: "F j, Y",
                                                            dateFormat: "Y-m-d",
                                                            minDate: "today"
                                                        }}
                                                                  />
                                                        <ErrorMessage
                                                          name="openhouseDate"
                                                          component="div"
                                                          className="invalid-feedback"
                                                        />
                                                          </FormGroup>
                                                    </Col>
                                                       <Col md="2">
                                                    <FormGroup className="">
                                                        <Label htmlFor="startHrs">
                                                          {this.props.t("Enter start time *")}
                                                        </Label>
                                                       
                                                     
                                                          <TimePicker
                                                          name="openhouseStartTime"
                                                          label=""
                                                          value={values.openhouseStartTime}
                                                          onChange={(val) => setFieldValue("openhouseStartTime", val)}
                                                          onBlur={() => setFieldTouched("openhouseStartTime", true)}
                                                          minTime={null}
                                                          error={errors.openhouseStartTime}
                                                          touched={touched.openhouseStartTime}
                                                        />
                                                        </FormGroup>
                                                    </Col>
                                                      <Col md="2">
                                                    <FormGroup className="">
                                                        <Label htmlFor="endHrs">
                                                          {this.props.t("Enter end time *")}
                                                        </Label>
                                                       
                                                      
                                                          <TimePicker
                                                            name="openhouseEndTime"
                                                            label=""
                                                            value={values.openhouseEndTime}
                                                            onChange={(val) => setFieldValue("openhouseEndTime", val)}
                                                            onBlur={() => setFieldTouched("openhouseEndTime", true)}
                                                            minTime={values.openhouseStartTime}
                                                            disabled={!values.openhouseStartTime}
                                                            error={errors.openhouseEndTime}
                                                            touched={touched.openhouseEndTime}
                                                          />
                                                          </FormGroup>
                                                    </Col>
                                                      <Col md="2">
                                                      <FormGroup className="mb-3">
                                                        <Label htmlFor="openhouseType">
                                                          {this.props.t("Type")}
                                                        </Label>
                                                        <div className="clearfix"></div>
                                                         <div className="btn-group open-btn" role="group">
                                                        <SafeField
                                                          type="radio"
                                                          className="btn-check"
                                                          name="openhouseType"
                                                          id="btnradio4"
                                                          value="0"
                                                          checked={values.openhouseType === '0'}
                                                          onChange={e => {
                                                            handleChange(e);
                                                            setFieldValue('address', '');
                                                            setFieldValue('location', '');
                                                            setFieldValue('longitude', '');
                                                            setFieldValue('latitude', '');
                                                          }}
                                                        />
                                                        <label className="btn btn-outline-secondary" htmlFor="btnradio4">In-person</label>
                                
                                                        <SafeField
                                                          type="radio"
                                                          className="btn-check"
                                                          name="openhouseType"
                                                          id="btnradio5"
                                                          value="1"
                                                          checked={values.openhouseType === '1'}
                                                          onChange={e => {
                                                            handleChange(e);
                                                            setFieldValue('address', '');
                                                            setFieldValue('location', '');
                                                            setFieldValue('longitude', '');
                                                            setFieldValue('latitude', '');
                                                          }}
                                                        />
                                                        <label className="btn btn-outline-secondary" htmlFor="btnradio5">Online</label>
                                                      </div>
                                                    <ErrorMessage
                                                          name="openhouseType"
                                                          component="div"
                                                          className="invalid-feedback"
                                                        />
                                                      </FormGroup>
                                                    </Col>
                                            
                                                   
                                                    {values.openhouseType === '0' && (
                                                   
                                                    <Col md="4">
                                                      <FormGroup className="mb-3">
                                                        <Label htmlFor="addNote">
                                                          {this.props.t("Address")}
                                                        </Label>              
                                                    <PlacesAutocomplete
                                                            value={values.address}
                                                              onChange={(value) => setFieldValue('address', value)}
                                                              onSelect={(value) => this.handlePlaceSelected(value, setFieldValue)}
                                                            >
                                                              {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                                                                <div>
                                                                  <input
                                                                    {...getInputProps({
                                                                      placeholder: 'Enter Address...',
                                                                      className: 'form-control',
                                                                     
                                                                    })}
                                                                  />
                                                                  <div className="">
                                                                    {loading ? <div>Loading...</div> : null}
                                
                                                                    {suggestions.map((suggestion, i) => {
                                                                      const className = suggestion.active
                                                                        ? 'suggestion-item--active'
                                                                        : 'suggestion-item';
                                                                      const style = suggestion.active
                                                                        ? { backgroundColor: '#007BFF', color: '#fff', cursor: 'pointer', padding: '10px' }
                                                                        : { backgroundColor: '#fff', cursor: 'pointer', padding: '10px' };
                                
                                                                      return (
                                                                        <div
                                                                        key={i}
                                                                          {...getSuggestionItemProps(suggestion, {
                                                                            style,
                                                                          })}
                                                                        >
                                                                          {suggestion.description}
                                                                        </div>
                                                                      );
                                                                    })}
                                                                  </div>
                                                                </div>
                                                              )}
                                                            </PlacesAutocomplete>
                                
                                                                        <ErrorMessage
                                                                          name="eventLocation"
                                                                          component="div"
                                                                          className="invalid-feedback"
                                                                        />
                                                                      </FormGroup>
                                                    </Col>
                                                   
                                                    )}
                                                  {values.openhouseType === '1' && (
                                                    
                                                      
                                                  
                                                    <Col md="4">
                                                   <FormGroup className="mb-3">
                                                        <Label htmlFor="addNote">
                                                          {this.props.t("Link")}
                                                        </Label>
                                                       
                                                     
                                                                       
                                                                        <SafeField
                                                                          name="location"
                                                                          className={
                                                                            "form-control" +
                                                                            (errors.location && touched.location
                                                                            ? " is-invalid"
                                                                            : "")
                                                                        }
                                                                          onChange={handleChange}
                                                                          type="text"
                                                                        />
                                
                                                                        <ErrorMessage
                                                                          name="location"
                                                                          component="div"
                                                                          className="invalid-feedback"
                                                                        />
                                                                      </FormGroup>
                                                    </Col>
                                                   
                                                    )}
                                                  </Row>
                                
                                                       
 <h5 className="normal-text" style={{marginTop:10}}>Select documents to email to visitors after registration.
 
                                <Link to="#" onClick={this.toggleRightCanvas} className="btn btn-yellow float-end" style={{marginLeft:10}}><i className=" bx bxs-file-doc"></i> Add New</Link></h5>

                                                     <Row>
                        {map(documents, (document, dockey) => (
                          <div className="col-sm-6">

                          <div className="form-check form-check-primary mb-3" key={"doc" + dockey}>
                            <input
                              type="checkbox"
                              className="form-check-input rs-input-check"
                              id={"document_" + document.id}
                              onChange={() => {
                                const checkedItems = values.checkedItems.includes(document.id)
                                  ? values.checkedItems.filter(item => item !== document.id)
                                  : [...values.checkedItems, document.id];
                                setFieldValue('checkedItems', checkedItems);
                                if (!values.checkedItems.includes(document.id)) {
                                  const obj = JSON.parse(localStorage.getItem("authUser"));
                                      const token = obj.resultData.bearerToken;
                                      const str = 'Bearer ' + token;
                                     
                                      axios.put('https://rscoreapi.azurewebsites.net/api/ProjectDocument/UpdateOpenHouseProjectDocument', {
                                        id: document.id,
                                        isImageType: 0,
                                        isProjectOpenHouse: true,
                                        isProjectDownloadPrice: false
                                      }, {
                                        headers: {
                                          'Content-Type': 'application/json',
                                          'Authorization': str
                                        }
                                      })
                                    .then(response => {
                                      onGetProjectMedia(this.props.match.params.projectId);
                                    })
                                    .catch(error => {
                                      console.error(error);
                                      // Handle error
                                    });
                                }else {
                                  const obj = JSON.parse(localStorage.getItem("authUser"));
                                  const token = obj.resultData.bearerToken;
                                  const str = 'Bearer ' + token;
                                 
                                  axios.put('https://rscoreapi.azurewebsites.net/api/ProjectDocument/UpdateOpenHouseProjectDocument', {
                                    id: document.id,
                                    isImageType: 0,
                                    isProjectOpenHouse: false,
                                    isProjectDownloadPrice: false
                                  }, {
                                    headers: {
                                      'Content-Type': 'application/json',
                                      'Authorization': str
                                    }
                                  })
                                .then(response => {
                                  onGetProjectMedia(this.props.match.params.projectId);
                                  //onGetProjectOpenHouseFiles(localStorage.getItem("userId"))
                                })
                                .catch(error => {
                                  console.error(error);
                                  // Handle error
                                });
                                }
                              }}
                              defaultValue={document.id}
                              data-type="Document"
                              data-name={document.projectDocumentTitle}
                              checked={document.isProjectOpenHouse}
                            />

                            <label
                              className="form-check-label rs-lable-check me-2"
                              htmlFor={"document_" + document.id}
                            >
                              {document.projectDocumentTitle}
                            </label>
                            <a target="_blank" rel="noreferrer" className=" text-check-label" href={document.projectDocumentLink}> <i className=" fas fa-eye "></i></a>
                            
                          </div>
                       </div>
                                ))}
                          
                        {map(links, (link, linkkey) => (
                            <div className="col-sm-6">
                            <div className="form-check form-check-primary mb-3" key={"link" + linkkey}>
                            <input
                              type="checkbox"
                              className="form-check-input rs-input-check me-2"
                              id={"link_" + link.id}
                              onChange={() => {
                                const checkedItems = values.checkedItems.includes(link.id)
                                  ? values.checkedItems.filter(item => item !== link.id)
                                  : [...values.checkedItems, link.id];
                                setFieldValue('checkedItems', checkedItems);
                                if (!values.checkedItems.includes(link.id)) {
                                      const obj = JSON.parse(localStorage.getItem("authUser"));
                                      const token = obj.resultData.bearerToken;
                                      const str = 'Bearer ' + token;
                                     
                                      axios.put('https://rscoreapi.azurewebsites.net//api/ProjectLink/UpdateOpenHouseProjectLink', {
                                        id: link.id,
                                        isImageType: 0,
                                        isProjectOpenHouse: true,
                                        isProjectDownloadPrice: false
                                      }, {
                                        headers: {
                                          'Content-Type': 'application/json',
                                          'Authorization': str
                                        }
                                      })
                                    .then(response => {
                                      onGetProjectLink(this.props.match.params.projectId)
                                    
                                    })
                                    .catch(error => {
                                      console.error(error);
                                    
                                    });
                                }else {
                                  const obj = JSON.parse(localStorage.getItem("authUser"));
                                      const token = obj.resultData.bearerToken;
                                      const str = 'Bearer ' + token;
                                     
                                      axios.put('https://rscoreapi.azurewebsites.net//api/ProjectLink/UpdateOpenHouseProjectLink', {
                                        id: link.id,
                                        isImageType: 0,
                                        isProjectOpenHouse: false,
                                        isProjectDownloadPrice: false
                                      }, {
                                        headers: {
                                          'Content-Type': 'application/json',
                                          'Authorization': str
                                        }
                                      })
                                    .then(response => {
                                      onGetProjectLink(this.props.match.params.projectId)
                                    
                                    })
                                    .catch(error => {
                                      console.error(error);
                                    
                                    });
                                }
                              }}
                              checked={link.isProjectOpenHouse}
                            />

                            <label
                              className="form-check-label rs-lable-check me-2"
                              htmlFor={"link_" + link.id}
                            >
                              {link.projectLinkTitle} 
                            
                            </label>
                              <a target="_blank" rel="noreferrer" className=" text-check-label" href={link.projectLinkUrl}><i className=" fas fa-eye "></i></a>
                          </div>
                          </div>

                        ))}
                         </Row>
                                                  <div className="clearfix">
                                                    <SaveButton>Save</SaveButton>
                                                   </div>
                                
                                
                                                </Form>
                                              )}
                                                      </Formik>

                               
                                {/* <Row>
                        <Col sm="12">
                        <Formik
                  enableReinitialize={true}
                  initialValues={{
                    agentId:parseInt(localStorage.getItem("userId")),
                    documentType: 0,
                    projectId: parseInt(projectData.id),
                    projectGuid:projectData.preConsProjectGuid,
                    projectLinkUrl: (this.state && this.state.projectLinkTitle) || "",
                    checkedItems: []

                  }}
                  validationSchema={Yup.object().shape({
                    
                  })}

                  onSubmit={this.handleProjectLinkSubmit}
                >
                  {({ errors, touched, values, handleChange, setFieldValue }) => (
                    <Form
                      className="needs-validation"
                    >
                     
                         <button className="btn btn-save"><i className="font-size-16 align-middle btn-i bx bx-save"></i>Save</button>
                        </Form>

                      )}
                      </Formik>
                        </Col>                  
                      </Row> */}
                                </CardBody>
                                </Card>
                                              </Col>
                                          
                                       
                          </Row>
               
                    </TabContent>
                  </CardBody>
                </Card>
              </Col>
            </Row>
            <Offcanvas
                      isOpen={this.state.isRight}
                      direction="end"
                      toggle={this.toggleRightCanvas}
                    >
                      <OffcanvasHeader toggle={this.toggleRightCanvas}>
                        Upload New Document 
                      </OffcanvasHeader>
                      <OffcanvasBody>
                      <Nav pills className="navtab-bg nav-justified">
                      <NavItem>
                        <NavLink
                          style={{ cursor: "pointer" }}
                          className={classnames({
                            active: this.state.activeTab1 === "1",
                          })}
                          onClick={() => {
                            this.toggle1("1");
                          }}
                        >
                          Document
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          style={{ cursor: "pointer" }}
                          className={classnames({
                            active: this.state.activeTab1 === "2",
                          })}
                          onClick={() => {
                            this.toggle1("2");
                          }}
                        >
                          Link
                        </NavLink>
                      </NavItem>
                    
                    </Nav>
                    <TabContent
                      activeTab={this.state.activeTab1}
                      className="p-3 text-muted"
                    >
                      <TabPane tabId="1">
                           <Formik
                                                    enableReinitialize={true}
                                                    initialValues={{
                                                      projectDocumentTitle: (this.state && this.state.projectDocumentTitle) || "",
                                                      projectDocumentTypeId: 0,
                                                      projectId: projectData.id,
                                                      projectGuid:projectData.preConsProjectGuid,
                                                      agentId: localStorage.getItem('userId'),
                                                      //projectDocumentContent:this.state.files.base64
                          
                                                    }}
                                            validationSchema={Yup.object().shape({
                                              projectDocumentTitle: Yup.string().max(50, "Title must not exceed 50").required("This is Required")
                                            })}
                          
                                            onSubmit={this.handleProjectDocumentSubmit}
                                          >
                                            {({ errors, touched, values, handleChange, setFieldValue }) => (
                                              <Form
                                                className="needs-validation"
                                              >
                                   
                                          
                                        
                                             <Row>
                                                  <Col sm="12">
                                                  <FormGroup className="mb-3">
                                                      <Label htmlFor="projectDocumentTitle">
                                                        {this.props.t("Title*")}
                                                      </Label>
                                                      <SafeField
                                                        name="projectDocumentTitle"
                                                        onChange={handleChange}                            
                                                        type="text"
                                                        
                                                        className={
                                                          "form-control" +
                                                          (errors.projectDocumentTitle && touched.projectDocumentTitle
                                                            ? " is-invalid"
                                                            : "")
                                                        }
                                                       
                                                        id="projectDocumentTitle"
                                                      />
                                                       <ErrorMessage
                                                        name="projectDocumentTitle"
                                                        component="div"
                                                        className="invalid-feedback"
                                                      />
                                                    </FormGroup>
                                                  </Col>
                                                  {/* <Col sm="12">
                                                  <FormGroup className="mb-3">
                                                      <Label htmlFor="projectDocumentTypeId">
                                                        {this.props.t("Type")}
                                                      </Label>
                                                      <SafeField as="select" name="projectDocumentTypeId" className="form-control" onChange={handleChange}>
                                                          <option value="0">Select</option>
                                                          {
                                                                      this.state.docTypes
                                                                        .map(docType =>
                                                                          <option key={docType.id} value={docType.id}>{docType.projectDocumentTypeTitle}</option>
                                                                        )
                                                                    }
                                                      </SafeField>
                                                    </FormGroup>
                                                  </Col> */}
                                                  <Col sm="12">
                                                  <div className="form-group mb-3">
                                                    <Label htmlFor="file">File upload</Label>
                                                    <input
                                                              type="file"
                                                              className="form-control"
                                                              onChange={event => this.handleFileChange(event, setFieldValue)}
                                                            />
                                                    
                                                    
                                                  </div>
                                                 
                                                  </Col>
                          
                                                 
                                                  
                                                  <div className="clearfix">
                                                  {fileUploaded && <SaveButton>Upload</SaveButton>}
                                                    
                                                    </div>
                                                  
                                              </Row>
                          
                                          
                                     
                                          
                                      </Form>
                                            )}
                                              </Formik>

                      </TabPane>
                      <TabPane tabId="2">
                            <Formik
                                          enableReinitialize={true}
                                          initialValues={{
                                            projectId: parseInt(projectData.id),
                                            projectGuid:this.props.match.params.projectId,
                                            projectLinkTitle: (this.state && this.state.projectLinkTitle) || "",
                                            projectLinkUrl: (this.state && this.state.projectLinkTitle) || "",
                        
                                          }}
                                          validationSchema={Yup.object().shape({
                                            projectLinkTitle: Yup.string().required("This is Required"),
                                            projectLinkUrl: Yup.string().required("This is Required")
                                          })}
                        
                                          onSubmit={this.handleProjectLinkSubmit}
                                        >
                                          {({ errors, touched, values, handleChange, setFieldValue }) => (
                                            <Form
                                              className="needs-validation"
                                            >
                                   
                                        
                                      
                                           <Row>
                                                <Col sm="12">
                                                <FormGroup className="mb-3">
                                                    <Label htmlFor="projectLinkTitle">
                                                      {this.props.t("Title*")}
                                                    </Label>
                                                    <SafeField
                                                      name="projectLinkTitle"
                                                      onChange={handleChange}                            
                                                      type="text"
                                                      
                                                      className={
                                                        "form-control" +
                                                        (errors.projectLinkTitle && touched.projectLinkTitle
                                                          ? " is-invalid"
                                                          : "")
                                                      }
                                                     
                                                      id="projectLinkTitle"
                                                    />
                                                     <ErrorMessage
                                                      name="projectLinkTitle"
                                                      component="div"
                                                      className="invalid-feedback"
                                                    />
                                                  </FormGroup>
                                                </Col>
                                               
                                                
                        
                                                <Col sm="12">
                                                <FormGroup className="mb-3">
                                                    <Label htmlFor="projectLinkUrl">
                                                      {this.props.t("Link*")}
                                                    </Label>
                                                    <SafeField
                                                      name="projectLinkUrl"
                                                      onChange={handleChange}                             
                                                      type="text"
                                                      className={
                                                        "form-control" +
                                                        (errors.projectLinkUrl && touched.projectLinkUrl
                                                          ? " is-invalid"
                                                          : "")
                                                      }
                                                     
                                                      id="projectLinkUrl"
                                                    />
                                                     <ErrorMessage
                                                      name="projectLinkUrl"
                                                      component="div"
                                                      className="invalid-feedback"
                                                    />
                                                  </FormGroup>
                                                </Col>
                                                <Col sm="12">
                                                <div className="clearfix">
                                                  <SaveButton>Add Link</SaveButton>
                                                
                                                  
                                                  </div>
                                                </Col>
                                            </Row>
                        
                                        
                                   
                                        
                                    </Form>
                                          )}
                                            </Formik>                    
                      </TabPane>
                      
                    </TabContent>
                       
                      </OffcanvasBody>
                      </Offcanvas>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

ProjectsCreate.propTypes = {
  t: PropTypes.any,
  history: PropTypes.object,
  apiError: PropTypes.any,
  ongetProjectUUIDAction: PropTypes.func,
  match: PropTypes.object,
  projectData: PropTypes.object,
  loading: PropTypes.object,
  documents:PropTypes.array,
  onGetProjectMedia:PropTypes.func,
  addProjectMedia:PropTypes.func,
  addProjectLink:PropTypes.func,
  links:PropTypes.array,
  onGetProjectLink:PropTypes.func,
  opfiles:PropTypes.array,
  onGetProjectOpenHouseFiles:PropTypes.func,
  onDeleteFile:PropTypes.func,
  addOpenhouseForm: PropTypes.func,
  onGetOpenhouseForm: PropTypes.func,
  openhouseformdatass: PropTypes.array,
  isResponsive:PropTypes.object
};
const mapStateToProps = ({ Project }) => (
{
  links: Project.links,
  documents: Project.documents,
  projectData: Project.projectData,
  opfiles:Project.opfiles,
  loading: Project.loading,
  openhouseformdatass: Project.openhouseformdatass

});
const mapDispatchToProps = dispatch => ({
  ongetProjectUUIDAction: id => dispatch(getProjectUUIDAction(id)),
  addProjectMedia: (data) => dispatch(addProjectMedia(data)),
  onGetProjectMedia:(projectId) => dispatch(getProjectMedia(projectId)),
  addProjectLink: (data) => dispatch(addProjectLink(data)),
  onGetProjectLink:(projectId) => dispatch(getProjectLink(projectId)),
  onGetProjectOpenHouseFiles:(agentId) => dispatch(getProjectOpenHouseFiles(agentId)),
  onDeleteFile:(id) => dispatch(deleteProjectOpenHouseFile(id)),
  addOpenhouseForm: (data) => dispatch(addOpenhouseForm(data)),
  onGetOpenhouseForm:(projectId) => dispatch(getOpenhouseForm(projectId))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(withTranslation()(ProjectsCreate)));
